import React from "react";
import { useTranslation } from "react-i18next";
import { Dialog, DialogHeader, DialogTitle, DialogBody, DialogFooter } from "../../../Shared/Dialog";
import Button from "../../../Shared/Buttons/Button";

export default function DeleteScenarioDialog({ open, scenarioName, onConfirm, onClose }) {
  const { t } = useTranslation();
  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs">
      <DialogHeader closeable={false}>
        <DialogTitle>{t("projectionsTab.deleteScenarioTitle")}</DialogTitle>
      </DialogHeader>
      <DialogBody>
        <p style={{ margin: 0, fontSize: 14, fontFamily: "Lato, sans-serif", color: "#6b7280" }}>
          {t("projectionsTab.deleteScenarioBody", { name: scenarioName })}
        </p>
      </DialogBody>
      <DialogFooter>
        <Button variant="light" size="small" onClick={onClose}>{t("common.cancel")}</Button>
        <Button variant="destructive" size="small" onClick={onConfirm}>{t("common.delete")}</Button>
      </DialogFooter>
    </Dialog>
  );
}
